import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/qms.json';
import ar from './i18n/ar/qms.json';

registerFeatureI18n('qms', { en, ar });

export { QmsSetupPage } from './QmsSetupPage';
export { QmsWorkstationPage } from './QmsWorkstationPage';
export { QmsIssuePage } from './QmsIssuePage';
export { QmsDisplayBoardPage } from './QmsDisplayBoardPage';
export { KioskPage } from './KioskPage';
export { DisplaysListPage } from './DisplaysListPage';
export { DisplayEditPage } from './DisplayEditPage';
